import { Location } from '@app/shared/routes';

export const CreateTermConditionFormLocation = new Location({
  path: '/legal/term-condition/create'
});
